import React, { createContext, useState, useEffect } from "react";
import { getPatientAssignments } from "../../utils/services/Patients/getPatientAssignments";
import { useValidToken } from "../../hooks/useValidToken";

export const PatientAssignmentContext = createContext();

export const PatientAssignmentProvider = ({ children }) => {
  const [assignments, setAssignments] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const { isValid, authLoading } = useValidToken();


  const [page, setPage] = useState(0); // <- controlado aquí
  const [pageSize, setPageSize] = useState(50);

  const [locationId, setLocationId] = useState(null);
  const [memberType, setMemberType] = useState(null);

  const fetchData = async () => {

    setLoading(true);
    try {
      const res = await getPatientAssignments({
        page: page + 1,
        pageSize,
        locationId,
        memberType,
      });

      setAssignments(res.data.map((p) => ({ ...p, id: p.cipId })));
      setTotal(res.total);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (authLoading || !isValid) return;
    fetchData();
  }, [page, pageSize, locationId, memberType, authLoading, isValid]);

  return (
    <PatientAssignmentContext.Provider
    value={{
      assignments,
      total,
      page,
      pageSize,
      loading,
      setPage,
      setPageSize,
      setLocationId,
      setMemberType,
      locationId,
      memberType, // aquí
    }}
    >
      {children}
    </PatientAssignmentContext.Provider>
  );
};